<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="name">
        <el-input v-model="queryParams.name" placeholder="国家名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="countryEn">
        <el-input v-model="queryParams.countryEn" placeholder="国家英文名称" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="currency">
        <el-input v-model="queryParams.currency" placeholder="币种" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" size="medium" icon="el-icon-plus" @click.native="add">新增</el-button>
        <el-button type="primary" size="medium" icon="el-icon-refresh" @click.native="sync">同步汇率</el-button>
        <el-button type="success" size="medium" icon="el-icon-document-copy" @click.native="batchUpdateRate">批量同步</el-button>
      </el-form-item>
    </el-form>
    <!--搜索-->
    <!--列表-->
    <el-table :data="tableData" ref="tableData" border v-loading="loading" 
      @selection-change="handleSelectionChange"
      :row-class-name="tableRowClassName"
      @cell-click="cellClick">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="country" label="国家编码" min-width="80" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="name" label="国家名称" align="center" min-width="120" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="countryEn" label="国家英文名称" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="currency" label="币种" align="center" min-width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="currencySymbol" label="币种符号" align="center" min-width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="symbolPosition" label="符号位置" align="center" min-width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="decimalPlaces" label="精度" align="center" min-width="60" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="exchangeRateCny" label="汇率（1元人民币）" align="center" min-width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
            <el-input v-if="scope.row.index === tabClickIndex" v-model="scope.row.exchangeRateCny" v-focus
                        size="small" type="text" @blur="inputBlur(scope.row)" 
                        placeholder="请输入汇率"/>
            <div v-else  style="cursor: pointer; min-height: 40px; line-height: 40px;">
              <span>{{ scope.row.exchangeRateCny }}</span>
              <i style="margin-left: 5px" class="el-icon-edit"></i>
            </div>
          </template>
      </el-table-column>
      <el-table-column prop="exchangeRateCnyOntime" label="实时汇率（1元人民币）" align="center" min-width="100" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ scope.row.exchangeRateCnyOntime }}</span>
          <i v-if="scope.row.exchangeRateCnyOntime>scope.row.exchangeRateCny" style="margin-left: 5px ; color: red" class="el-icon-top"></i>
          <i v-if="scope.row.exchangeRateCnyOntime<scope.row.exchangeRateCny" style="margin-left: 5px ; color: #42b983" class="el-icon-bottom"></i>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" min-width="60">
          <template slot-scope="{row}">
              <el-switch
                v-model="row.status"
                active-color="#13ce66"
                active-value="1"
                inactive-value="0" 
                @change="changeStatus(row)">
              </el-switch>
          </template>
      </el-table-column>
      <!--操作-->
      <el-table-column label="操作" min-width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-edit" @click="updateRow(scope.row)" >编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
    />
    <!-- 表单 -->
    <el-dialog :title="title" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="600px" append-to-body v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" ref="form" :rules="rules">
        <el-form-item label="国家编码:" prop="country" label-width="100px">
          <el-input v-model="form.country" autocomplete="off" style="width: 85%"></el-input>
        </el-form-item>
        <el-form-item label="国家名称:" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off" style="width: 85%" ></el-input>
        </el-form-item>
        <el-form-item label="国家英文名:" prop="countryEn" label-width="100px">
          <el-input v-model="form.countryEn" autocomplete="off" style="width: 85%" ></el-input>
        </el-form-item>
        <el-form-item label="币种:" prop="currency" label-width="100px">
          <el-input v-model="form.currency" autocomplete="off" style="width: 85%" ></el-input>
        </el-form-item>
        <el-form-item label="币种符号:" prop="currencySymbol" label-width="100px">
          <el-input v-model="form.currencySymbol" autocomplete="off" style="width: 85%" ></el-input>
        </el-form-item>
        <el-form-item label="符号位置:" prop="symbolPosition" label-width="100px">
          <el-select v-model="form.symbolPosition" clearable>
            <el-option
              v-for="item in posOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="精度:" prop="decimalPlaces" label-width="100px">
          <template>
            <el-input-number v-model="form.decimalPlaces" controls-position="right" :min="1" :max="10"></el-input-number>
          </template>
        </el-form-item>
        <el-form-item label="汇率:" prop="exchangeRateCny" label-width="100px">
          <template>
            <el-input v-model="form.exchangeRateCny" autocomplete="off" style="width: 85%" placeholder="人民币"></el-input>
          </template>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelDialog()">取消</el-button>
        <el-button type="success" @click="submitForm()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { currencyPageList,currencyDetail,submitCurrency,changeCurrencyStatus,syncCurrencyRate,editCurrencyRate , batchCurrencyUpdate} from "@/api/config.js";

  export default {
    name: 'currency',
    directives: {
      focus: {
        inserted(el) {
          el.querySelector('input').focus()
        }
      }
    },
    data () {
      return {
        loading: false,
        tabClickIndex: null,
        queryParams: {
          name: undefined,
          countryEn: undefined,
          currency: undefined
        },
        tableData: [],
        page: 1,
        pageSize: 20,
        total: 0,
        posOptions:[
          {
            value: 'prefix',
            label: 'prefix'
          }, {
            value: 'suffix',
            label: 'suffix'
          }
        ],
        //表单
        title:"",
        method:'add',
        dialog:false,
        form:{},
        rules:{
          name:[
            { required: true, message: "请输入国家名称", trigger: "blur" }
          ],
          country:[
            { required: true, message: "请输入国家名称", trigger: "blur" }
          ],
          countryEn:[
            { required: true, message: "请输入国家英文名称", trigger: "blur" }
          ],
          currency:[
            { required: true, message: "请输入币种", trigger: "blur" }
          ],
          currencySymbol:[
            { required: true, message: "请输入币种符号", trigger: "blur" }
          ],
          symbolPosition:[
            { required: true, message: "请选择符号位置", trigger: "blur" }
          ],
          decimalPlaces:[
            { required: true, message: "请输入精度", trigger: "blur" }
          ],
          exchangeRateCny:[
            { required: true, message: "请输入汇率（人民币）", trigger: "blur" }
          ]
        },
        multipleSelection: []
      }
    },
    computed: {
      adminShow () {
        return this.$store.getters.user.userType == "1";
      }
    },
    methods: {
      // 搜索
      search () {
        this.tableData = [];
        this.page = 1;
        this.initData();
      },
      // 重置
      resetQuery () {
        this.resetForm("queryForm");
        this.search();
      },
      // 获取列表
      initData () {
        let params = {
          model: this.queryParams,
          page: this.page,
          pageSize: this.pageSize,
        };
        this.loading = true;
        this.tableData = [];
        currencyPageList(params).then(res => {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        })
      },
      // 选择行
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 弹窗
      dialogClose(){
        this.$refs.form.clearValidate();
        this.dialog = false;
      },
      // 弹窗的取消
      cancelDialog(){
        this.dialog = false;
      },
      //提交表单
      submitForm(){
        this.$refs.form.validate(valid=>{
          if (valid) {
            let params ={
              ...this.form
            }
            submitCurrency(params).then(res=>{
              if(res.data.code == 200){
                this.$notify({
                  title: '成功',
                  message: '保存货币汇率成功',
                  type: 'success'
                });
                this.dialog = false;
                this.initData();
              }
            })
          }
        });
      },
      // 编辑
      updateRow(row){
        this.dialog = true;
        this.title = "编辑货币汇率";
        currencyDetail({id: row.id}).then(res=>{
          if(res.data.code == 200){
            this.form = res.data.data;
          }
        })
      },
      add(){
        this.title = "新增货币汇率";
        this.dialog = true;
        this.form = {};
      },
      //修改状态
      changeStatus(row){
        const newStatus = row.status;
        let params = {
          id: row.id, 
          currency: row.currency, 
          status: newStatus
        };
        changeCurrencyStatus(params).then(res=>{
            this.$notify({
              title: '成功',
              message: newStatus === '1' ? '启用成功' : '禁用成功',
              type: 'success'
            });
            this.initData(); 
        }).catch(() => {
          row.status = newStatus === '1' ? '0' : '1';
        });
      },
      sync(){
        syncCurrencyRate().then(res=>{
          if(res.data.code == 200){
            this.$notify({
              title: '成功',
              message: '同步成功',
              type: 'success'
            });
            this.initData();
          }
        })
      },
      tableRowClassName({ row, rowIndex }) {
        row.index = rowIndex
      },
      cellClick(row, column, cell, event) {
        if (column.property === 'exchangeRateCny') {
          this.tabClickIndex = row.index
        } else {
          this.tabClickIndex = null
        }
      },
      inputBlur(row) {
        this.tabClickIndex = null;
        let params = {id: row.id, currency: row.currency, exchangeRateCny: row.exchangeRateCny}
        if (!params.exchangeRateCny) {
          return;
        }
        editCurrencyRate(params).then(res=>{
          if(res.data.code == 200){
            this.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success'
            });
          }
        })
      },
      batchUpdateRate(){
        if(this.multipleSelection.length == 0){
          this.$notify({
            title: '提示',
            message: '请选择要同步的汇率',
            type: 'warning'
          });
          return;
        }
        let params = {
          ids: this.multipleSelection.map(item => item.id)
        }
        this.$confirm('确定要批量同步选中的汇率数据吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          batchCurrencyUpdate(params).then(res => {
            this.$notify({
              title: '成功',
              message: '批量同步汇率成功',
              type: 'success'
            });
            this.initData(); // 重新加载数据
            this.$refs.tableData.clearSelection(); // 清除选中状态
          }).catch(() => {
            this.$notify({
              title: '失败',
              message: '批量同步汇率失败',
              type: 'error'
            });
          });
        }).catch(() => {
        });

      }
    },
    mounted () {
      this.initData();
    },
    watch: {
        '$route': {
            handler: function (to, from) {
                if (to.name == "currency") {
                    this.initData();
                }
            },
            // 深度观察监听
            deep: true,
        },
    },
  };
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 10px;
  .el-form-item {
    margin-bottom: 0px;
  }
}

</style>
